<template>
    <div class="card card-info">
        <div class="card-header">
            <h4 class="card-title float-start">{{esercizio.nome}}</h4>
        </div>
        <div class="m-2">
            <div class="row" align="left">
                <div class="col-2">
                    <p><strong>Descrizione:</strong></p>
                </div>
                <div class="col-10">
                    <p>{{esercizio.descrizione}}</p>
                </div>
            </div>
            <div class="row" align="left">
                <div class="col-2">
                    <p><strong>Obiettivo:</strong></p>
                </div>
                <div class="col-10">
                    <p>{{esercizio.obiettivo}}</p>
                </div>
            </div>
            <div class="row" align="left">
                <div class="col-2">
                    <p><strong>Minuti Esecuzione:</strong></p>
                </div>
                <div class="col-10">
                   <p>{{esercizio.minuti}}</p>
                </div>
            </div>   
            <div class="row" align="left">
                <div class="col-2">
                    <p><strong>Creato da:</strong></p>
                </div>
                <div class="col-10">
                   <p>{{esercizio.user.name}}</p>
                </div>
            </div>  
        </div>
                
    </div>

    <div class="card card-info mt-3">
        <div class="card-header">
            <h4 class="card-title float-start">Attrezzi Necessari</h4>
        </div>
        <form @submit.prevent="submit">
            <div class="row m-2" align="left">
                <div class="col-10">
                    <div class="input-group">
                        <select class="form-select" aria-label="attrezzo" v-model="form.attrezzo">
                            <option v-for="item in attrezzi" :value="item.id" :key="item.id">
                                {{ item.nome }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-2">
                    <button class="btn btn-outline-dark" type="submit">
                        Aggiungi
                    </button>
                </div>
            </div>        
        </form>

        <div
            class="alert alert-primary d-flex align-middle my-auto m-2"
            role="alert"
            v-if="esercizio.attrezzi.length == 0"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
            >
                <path
                    d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
            </svg>
            <div>Non sono presenti attrezzi. Aggiungine uno per iniziare a gestirlo :)</div>
        </div>


        <table class="table" v-if="esercizio.attrezzi.length > 0">
            <thead>
                <tr>
                    <th scope="col">Nome</th>
                    <th scope="col">Azione</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="esercizio_attrezzo in esercizio.attrezzi" :key="esercizio_attrezzo.id">
                    <td>{{ esercizio_attrezzo.attrezzo.nome }}</td>
                    <td>
                        <delete-button
                            :id="esercizio_attrezzo.id"
                            @click="confirnDelete(esercizio_attrezzo)"
                        />    
                    </td>
                    
                </tr>
            </tbody>
        </table>
    </div>

    <div class="card card-info mt-3">
        <div class="card-header">
            <h4 class="card-title float-start">Foto</h4>
        </div>
        <div v-if="esercizio.foto == null" class="m-2">
            <form @submit="submitFormFoto" enctype="multipart/form-data">
                <div class="input-group">
                    <div class="custom-file">
                        <input type="file" name="filename" class="custom-file-input" id="inputFileUpload" v-on:change="onFileChange">
                    </div>
                    <div class="input-group-append">
                        <input type="submit" class="btn btn-primary" value="Invia Foto">
                    </div>
                </div>
            </form>    
        </div>
        <div class="m-2" v-if="esercizio.foto != null">
            <div class="row" align="left">
                <div class="col-8">
                    <a :href="'/upload/'+esercizio.foto" target="_blank"><img :src="'/upload/'+esercizio.foto" class="img-thumbnail" alt="foto esercizio"></a>
                </div>
            </div>
        </div>

        
    </div>

    <div class="card card-info mt-3">
        <div class="card-header">
            <h4 class="card-title float-start">Video</h4>
        </div>
        <div v-if="esercizio.video == null" class="m-2">
            <form @submit="submitFormVideo" enctype="multipart/form-data">
                <div class="input-group">
                    <div class="custom-file">
                        <input type="file" name="filenameVideo" class="custom-file-input" id="inputFileUpload" v-on:change="onFileChangeVideo">
                    </div>
                    <div class="input-group-append">
                        <input type="submit" class="btn btn-primary" value="Invia Video">
                    </div>
                </div>
            </form>    
        </div>
        <div class="m-2" v-if="esercizio.video != null">
            <div class="row" align="left">
                <div class="col-8">
                    <video width="400" controls>
                      <source :src="'/upload/'+esercizio.video" type="video/mp4">
                      Your browser does not support HTML video.
                    </video>
                </div>
            </div>
        </div>

        
    </div>
    
</template>
<script>
import Main from "@/Layouts/Main.vue";
import Show from "@/Pages/Esercizio/Show.vue";
import ShowButton from "@/Components/ShowButton.vue";
import EditButton from "@/Components/EditButton.vue";
import DeleteButton from "@/Components/DeleteButton.vue";
import ConfirmBox from "@/Components/ConfirmBox.vue";
import Pagination from "@/Components/Pagination.vue";

export default {
    layout: Main,
    props: {
        auth: Object,
        errors: Object,
        esercizio: Object,
        attrezzi: Array,
        flash: Object,
    },
    components: {
        Show,
        ShowButton,
        EditButton,
        DeleteButton,
        ConfirmBox,
        Pagination,
    },
    data() {
        return {
            form: this.$inertia.form({
                attrezzo: 0,
                esercizio: this.esercizio.id
            }),
            name: '',
            file: '',
            fileVideo: ''
        };
    },
    methods: {

        submit() {
            let route = this.route("esercizi.aggiungi_attrezzo")
            let method = 'post'
            if (this.form.attrezzo != 0){
                this.form['post'](route, {
                onError: (errors) => {
                    
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        
                        if (errors.hasOwnProperty("nome")) {
                            toast.message = errors.nome;
                            this.errors.nome = errors.nome;
                        }

                    }
                }, 
                onSuccess: () => {
                    this.form.reset();
                    this.modal.hide();

                }
            });
            }
            
        },

        confirnDelete(esercizio_attrezzo){
            this.$inertia.delete(
                this.route("esercizi.elimina_attrezzo", esercizio_attrezzo.id)
            );
        },

        onFileChange(e) {
            console.log(e.target.files[0]);
            this.filename = "Selected File: " + e.target.files[0].name;
            this.file = e.target.files[0];
        },

        onFileChangeVideo(e) {
            console.log(e.target.files[0]);
            this.fileVideo = e.target.files[0];
        },
        submitFormFoto(e) {
            e.preventDefault();
            let currentObj = this;
            const config = {
            headers: {
            'content-type': 'multipart/form-data',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            }
            }
            // form data
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('id', this.esercizio.id);
            // send upload request
            axios.post('/esercizi/upload_foto', formData, config)
            .then(function (response) {
                console.log('success');
                currentObj.success = response.data.success;
                currentObj.filename = "";

                var toast = {
                        bg: "bg-success",
                        message: 'File inviato con successo!',
                };
                if (toast) {
                    currentObj.$store.dispatch("showToast", toast);
                }
                location.reload();
            })
            .catch(function (error) {
                console.log('error');
                console.log(error);
                var toast = {
                        bg: "bg-danger",
                        message: error,
                };
                if (toast) {
                    currentObj.$store.dispatch("showToast", toast);
                }
            });
            }   ,
        submitFormVideo(e) {
            e.preventDefault();
            let currentObj = this;
            const config = {
            headers: {
            'content-type': 'multipart/form-data',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            }
            }
            // form data
            let formData = new FormData();
            formData.append('file', this.fileVideo);
            formData.append('id', this.esercizio.id);
            // send upload request
            axios.post('/esercizi/upload_video', formData, config)
            .then(function (response) {
                console.log('success');
                currentObj.success = response.data.success;
                currentObj.filename = "";

                var toast = {
                        bg: "bg-success",
                        message: 'Video inviato con successo!',
                };
                if (toast) {
                    currentObj.$store.dispatch("showToast", toast);
                }
                location.reload();
            })
            .catch(function (error) {
                console.log('error video');
                console.log(error);
                var toast = {
                        bg: "bg-danger",
                        message: error,
                };
                if (toast) {
                    currentObj.$store.dispatch("showToast", toast);
                }
            });
            }        
    },

    computed: {
        
    },
    mounted() {
        this.$store.dispatch("setAuth", this.auth);

        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
    updated() {
        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
};
</script>
